// @ts-nocheck
import { Outlet, useOutletContext } from 'react-router-dom'
import type { CaseOutletContext } from './CaseLayout'
import { InvestigateContextProvider } from './InvestigateContext'
import { InvestigateFilterBar } from './InvestigateFilterBar'

export default function InvestigateLayout() {
  const parentCtx = useOutletContext<CaseOutletContext>()
  return (
    <InvestigateContextProvider>
      <InvestigateFilterBar />
      <div className="relative flex h-0 min-h-0 flex-1 flex-col overflow-hidden">
        <Outlet context={parentCtx} />
      </div>
    </InvestigateContextProvider>
  )
}
